import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _extends from "@babel/runtime/helpers/esm/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _excluded = ["transformActive"],
    _excluded2 = ["component", "theme"],
    _excluded3 = ["component", "theme"],
    _excluded4 = ["paddingInput"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;

import React from 'react';
import styled, { css } from 'styled-components';
export var InputBaseWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return _extends({}, theme.input.wrapper);
});
export var InputBaseContainer = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  border-color: ", ";\n  ", ";\n\n  &:hover,\n  &:focus-within {\n    border-color: ", ";\n  }\n"])), function (_ref2) {
  var theme = _ref2.theme,
      variant = _ref2.variant;
  return theme.input[variant].borderColor;
}, function (_ref3) {
  var theme = _ref3.theme;
  return _extends({}, theme.input.container);
}, function (_ref4) {
  var theme = _ref4.theme,
      variant = _ref4.variant;
  return theme.input[variant].borderColorActive;
});
export var LabelText = styled.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", ";\n\n  ", "\n\n  ", ":focus-within & {\n    transform: ", ";\n    color: ", ";\n  }\n"])), function (_ref5) {
  var theme = _ref5.theme;

  var _theme$input$labelTex = theme.input.labelText,
      transformActive = _theme$input$labelTex.transformActive,
      styles = _objectWithoutProperties(_theme$input$labelTex, _excluded);

  return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      ", "\n    "])), styles);
}, function (_ref6) {
  var inputHasValue = _ref6.inputHasValue;
  return inputHasValue && css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n      transform: ", ";\n    "])), function (_ref7) {
    var theme = _ref7.theme;
    return theme.input.labelText.transformActive;
  });
}, InputBaseContainer, function (_ref8) {
  var theme = _ref8.theme;
  return theme.input.labelText.transformActive;
}, function (_ref9) {
  var theme = _ref9.theme,
      variant = _ref9.variant;
  return theme.input[variant].labelTextActive;
});
export var HelperText = styled.span(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  color: ", ";\n  ", ";\n"])), function (_ref10) {
  var theme = _ref10.theme,
      variant = _ref10.variant;
  return theme.input[variant].helperText;
}, function (_ref11) {
  var theme = _ref11.theme;
  return _extends({}, theme.input.helperText);
});
export var Input = styled( /*#__PURE__*/React.forwardRef(function (_ref12, ref) {
  var Component = _ref12.component,
      theme = _ref12.theme,
      props = _objectWithoutProperties(_ref12, _excluded2);

  return /*#__PURE__*/React.createElement(Component, _extends({
    ref: ref
  }, props));
}))(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  ", ";\n"])), function (_ref13) {
  var theme = _ref13.theme;
  return _extends({}, theme.input.inputElement);
});
export var Icon = styled(function (_ref14) {
  var component = _ref14.component,
      theme = _ref14.theme,
      props = _objectWithoutProperties(_ref14, _excluded3);

  return /*#__PURE__*/React.cloneElement(component, props);
})(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  ", ";\n\n  & + ", " {\n    padding: ", ";\n  }\n"])), function (_ref15) {
  var theme = _ref15.theme;

  var _theme$input$icon = theme.input.icon,
      paddingInput = _theme$input$icon.paddingInput,
      styles = _objectWithoutProperties(_theme$input$icon, _excluded4);

  return css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n      ", "\n    "])), styles);
}, Input, function (_ref16) {
  var theme = _ref16.theme;
  return theme.input.icon.paddingInput;
});